// TEMPORARY dev page to compare the legacy canvas chart (left) against the new
// visx ReportJacquesChart (right) for every candidate curve (0..22) at a chosen
// age. Open at #/chart-comparison. Remove this file and its route when done.
import React, { useEffect, useRef, useState } from 'react';
import { TEXT_COLOR } from '../theme';
import { Box, Slider, Typography } from '@mui/material';
import { drawLines } from '../Jacques';
import { getChart } from '../utils/charts';
import ReportJacquesChart from './Report/ReportJacquesChart';

const CANVAS_W = 515;
const CANVAS_H = 506;
const CURVAS = Array.from({ length: 23 }, (_, i) => i); // 0..22

function LegacyChart({ curva, age }) {
    const canvasRef = useRef(null);
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return undefined;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, CANVAS_W, CANVAS_H);
        const img = new Image();
        let cancelled = false;
        img.src = getChart(undefined, undefined, false);
        img.onload = () => {
            if (cancelled) return;
            ctx.drawImage(img, 0, 0);
            drawLines(ctx, curva, age);
        };
        return () => { cancelled = true; };
    }, [curva, age]);
    return <canvas ref={canvasRef} width={CANVAS_W} height={CANVAS_H} style={{ maxWidth: '100%' }} />;
}

export default function ChartComparison() {
    const [age, setAge] = useState(25);

    return (
        <Box sx={{ p: 4, bgcolor: '#F4F5F7', minHeight: '100vh' }}>
            <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
                Comparación de curvas — viejo (canvas) vs nuevo (visx)
            </Typography>
            <Box sx={{ position: 'sticky', top: 0, zIndex: 1, bgcolor: '#F4F5F7', py: 2, maxWidth: 360 }}>
                <Typography sx={{ fontSize: 13, color: TEXT_COLOR }}>Edad: {age}</Typography>
                <Slider
                    value={age}
                    min={18}
                    max={64}
                    onChange={(_, v) => setAge(v)}
                    valueLabelDisplay="auto"
                />
            </Box>

            {CURVAS.map((curva) => (
                <Box key={curva} sx={{ mb: 4 }}>
                    <Typography sx={{ fontWeight: 600, mb: 1 }}>curva {curva}</Typography>
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                        gap: 3,
                        alignItems: 'center',
                    }}>
                        <Box sx={{ bgcolor: '#fff', p: 2, borderRadius: 2 }}>
                            <Typography sx={{ fontSize: 12, color: TEXT_COLOR, mb: 1 }}>VIEJO (canvas + PNG)</Typography>
                            <LegacyChart curva={curva} age={age} />
                        </Box>
                        <Box sx={{ bgcolor: '#fff', p: 2, borderRadius: 2 }}>
                            <Typography sx={{ fontSize: 12, color: TEXT_COLOR, mb: 1 }}>NUEVO (visx)</Typography>
                            <ReportJacquesChart curva={curva} age={age} />
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
}
